import { css } from '@/styled-system/css';

export const toastCloseStyles = css.raw({
  marginBlock: `calc(-1 * {spacing.default})`,
  marginInlineEnd: `calc(-1 * {spacing.default})`,
  marginInlineStart: 'default',
  paddingBlockStart: 'Toast.CloseButton.margin.top',
  paddingInlineEnd: 'Toast.CloseButton.margin.right',
});
